export const getActionCardColors = (actionTypeOrCard = "default") => {
  // Handle both string actionType and full card object
  let actionType = actionTypeOrCard;
  let effectValue = 0;
  
  if (typeof actionTypeOrCard === 'object' && actionTypeOrCard !== null) {
    actionType = actionTypeOrCard.actionType;
    effectValue = actionTypeOrCard.effectValue || 0;
  }
  
  // For manipulate cards, check effectValue to determine color
  if ((actionType === "manipulate" || actionType === "delayed_manipulate") && effectValue < 0) {
    // Negative effectValue = price decrease (red/orange)
    return {
      bg: "linear-gradient(145deg, rgba(255, 255, 255, 0.98), rgba(255, 243, 224, 0.98)), linear-gradient(135deg, rgba(239, 68, 68, 0.08) 0%, rgba(220, 38, 38, 0.05) 100%)",
      border: "#ef4444",
      header: "linear-gradient(135deg, rgba(239, 68, 68, 0.15), rgba(220, 38, 38, 0.1))",
      emoji: actionType === "manipulate" ? "📊" : "⏰",
      name: actionType === "manipulate" ? "red-negative" : "red-negative-delayed"
    };
  }
  
  switch(actionType) {
    case "forecast":
      return {
        bg: "linear-gradient(145deg, rgba(255, 255, 255, 0.98), rgba(250, 245, 255, 0.98)), linear-gradient(135deg, rgba(147, 51, 234, 0.1) 0%, rgba(126, 34, 206, 0.06) 100%)",
        border: "#9333ea",
        header: "linear-gradient(135deg, rgba(147, 51, 234, 0.18), rgba(126, 34, 206, 0.12))",
        emoji: "🤫",
        name: "purple-secretive"
      };
    case "shuffle":
      return {
        bg: "linear-gradient(145deg, rgba(255, 255, 255, 0.98), rgba(255, 245, 235, 0.98)), linear-gradient(135deg, rgba(251, 146, 60, 0.08) 0%, rgba(249, 115, 22, 0.05) 100%)",
        border: "#fb923c",
        header: "linear-gradient(135deg, rgba(251, 146, 60, 0.15), rgba(249, 115, 22, 0.1))",
        emoji: "🔀",
        name: "medium-orange"
      };
    case "manipulate":
      return {
        bg: "linear-gradient(145deg, rgba(255, 255, 255, 0.98), rgba(240, 253, 244, 0.98)), linear-gradient(135deg, rgba(34, 197, 94, 0.08) 0%, rgba(22, 163, 74, 0.05) 100%)",
        border: "#22c55e",
        header: "linear-gradient(135deg, rgba(34, 197, 94, 0.15), rgba(22, 163, 74, 0.1))",
        emoji: "📊",
        name: "green-positive"
      };
    case "delayed_manipulate":
      return {
        bg: "linear-gradient(145deg, rgba(255, 255, 255, 0.98), rgba(240, 253, 244, 0.98)), linear-gradient(135deg, rgba(34, 197, 94, 0.08) 0%, rgba(22, 163, 74, 0.05) 100%)",
        border: "#22c55e",
        header: "linear-gradient(135deg, rgba(34, 197, 94, 0.15), rgba(22, 163, 74, 0.1))",
        emoji: "⏰",
        name: "green-positive-delayed"
      };
    case "remove_manipulators":
      return {
        bg: "linear-gradient(145deg, rgba(255, 255, 255, 0.98), rgba(240, 245, 255, 0.98)), linear-gradient(135deg, rgba(59, 130, 246, 0.08) 0%, rgba(37, 99, 235, 0.05) 100%)",
        border: "#3b82f6",
        header: "linear-gradient(135deg, rgba(59, 130, 246, 0.15), rgba(37, 99, 235, 0.1))",
        emoji: "📰",
        name: "blue-fake-news"
      };
    case "trading_halt":
      return {
        bg: "linear-gradient(145deg, rgba(255, 255, 255, 0.98), rgba(243, 244, 246, 0.98)), linear-gradient(135deg, rgba(107, 114, 128, 0.12) 0%, rgba(75, 85, 99, 0.08) 100%)",
        border: "#6b7280",
        header: "linear-gradient(135deg, rgba(107, 114, 128, 0.2), rgba(75, 85, 99, 0.15))",
        emoji: "🚫",
        name: "gray-blocking"
      };
    case "tax_credit":
      return {
        bg: "linear-gradient(145deg, rgba(255, 255, 255, 0.98), rgba(254, 252, 232, 0.98)), linear-gradient(135deg, rgba(234, 179, 8, 0.1) 0%, rgba(202, 138, 4, 0.06) 100%)",
        border: "#eab308",
        header: "linear-gradient(135deg, rgba(234, 179, 8, 0.2), rgba(202, 138, 4, 0.15))",
        emoji: "💰",
        name: "gold-money"
      };
    case "rug_pull":
      // Style Rug Pull like a negative delayed manipulator (red, timer icon)
      return {
        bg: "linear-gradient(145deg, rgba(255, 255, 255, 0.98), rgba(255, 243, 224, 0.98)), linear-gradient(135deg, rgba(239, 68, 68, 0.08) 0%, rgba(220, 38, 38, 0.05) 100%)",
        border: "#ef4444",
        header: "linear-gradient(135deg, rgba(239, 68, 68, 0.15), rgba(220, 38, 38, 0.1))",
        emoji: "⏰",
        name: "red-negative-delayed-rug-pull"
      };
    case "forced_sale":
      return {
        bg: "linear-gradient(145deg, rgba(255, 255, 255, 0.98), rgba(255, 237, 213, 0.98)), linear-gradient(135deg, rgba(234, 88, 12, 0.12) 0%, rgba(194, 65, 12, 0.08) 100%)",
        border: "#ea580c",
        header: "linear-gradient(135deg, rgba(234, 88, 12, 0.22), rgba(194, 65, 12, 0.16))",
        emoji: "⚠️",
        name: "orange-forced"
      };
    case "transfer_manipulators":
      return {
        bg: "linear-gradient(145deg, rgba(255, 255, 255, 0.98), rgba(237, 233, 254, 0.98)), linear-gradient(135deg, rgba(139, 92, 246, 0.12) 0%, rgba(124, 58, 237, 0.08) 100%)",
        border: "#8b5cf6",
        header: "linear-gradient(135deg, rgba(139, 92, 246, 0.22), rgba(124, 58, 237, 0.16))",
        emoji: "🔄",
        name: "violet-transfer"
      };
    case "double_down":
      return {
        bg: "linear-gradient(145deg, rgba(255, 255, 255, 0.98), rgba(240, 253, 244, 0.98)), linear-gradient(135deg, rgba(34, 197, 94, 0.1) 0%, rgba(22, 163, 74, 0.06) 100%)",
        border: "#22c55e",
        header: "linear-gradient(135deg, rgba(34, 197, 94, 0.2), rgba(22, 163, 74, 0.14))",
        emoji: "📈",
        name: "green-double-down"
      };
    default:
      return {
        bg: "linear-gradient(145deg, rgba(255, 255, 255, 0.98), rgba(255, 247, 237, 0.98)), linear-gradient(135deg, rgba(249, 115, 22, 0.08) 0%, rgba(234, 88, 12, 0.05) 100%)",
        border: "#f97316",
        header: "linear-gradient(135deg, rgba(249, 115, 22, 0.15), rgba(234, 88, 12, 0.1))",
        emoji: "🎴",
        name: "action-orange"
      };
  }
};

